import { z } from 'zod';
import { EXIT_CRITERION_KINDS } from './report.js';
import { SignoffTermSchema } from './signoff.js';

export const ProjectSettingsSchema = z.object({
  signoff_term: SignoffTermSchema,
  gamification_enabled: z.boolean(),
  // #112 (A6): blendet die Quell-ID (`source_ref`) im Katalog und in der Testplan-Auswahl ein/aus.
  // Vorgabe eingeblendet — sie ist die Bruecke in die Importdatei. Wer ohne Quelldateien arbeitet,
  // schaltet sie ab, statt sie in jeder Zeile mitlesen zu muessen.
  show_source_ref: z.boolean(),
});
export type ProjectSettings = z.infer<typeof ProjectSettingsSchema>;
export const ProjectSettingsPatchSchema = ProjectSettingsSchema.partial();

// Editor-Payloads (Plan 7 Admin). color_token/kind bleiben Text (wie die Seed-Konvention),
// validiert gegen die bekannten Werte.
export const SeverityLevelInputSchema = z.object({
  key: z.string().min(1).max(40),
  label_de: z.string().min(1),
  label_en: z.string().min(1),
  rank: z.number().int().min(0),
  color_token: z.enum(['blocker', 'high', 'medium', 'low']),
  is_default: z.boolean(),
  sort_order: z.number().int(),
});
export type SeverityLevelInput = z.infer<typeof SeverityLevelInputSchema>;

export const ErrorTypeInputSchema = z.object({
  key: z.string().min(1).max(40),
  label_de: z.string().min(1),
  label_en: z.string().min(1),
  sort_order: z.number().int(),
});
export type ErrorTypeInput = z.infer<typeof ErrorTypeInputSchema>;

export const ExitCriterionInputSchema = z.object({
  key: z.string().min(1).max(40),
  label_de: z.string().min(1),
  label_en: z.string().min(1),
  kind: z.enum(EXIT_CRITERION_KINDS),
  threshold: z.number().int().min(0).max(100).nullable(),
  sort_order: z.number().int(),
});
export type ExitCriterionInput = z.infer<typeof ExitCriterionInputSchema>;

// Task B2 (#29 Finding 23): PUT /config/severity-levels bzw. /config/error-types darf einen noch
// verwendeten Eintrag nicht mehr still auf null setzen (defects.severity_id/error_type_id sind
// onDelete: set null). Bei einem Löschversuch eines verwendeten Keys antwortet der PUT stattdessen
// 409 mit genau dieser Zeilenform je betroffenem Eintrag — das Frontend zeigt sie namentlich statt
// eines generischen Fehlers.
export const UsageConflictEntrySchema = z.object({
  key: z.string(),
  label_de: z.string(),
  count: z.number().int(),
});
export type UsageConflictEntry = z.infer<typeof UsageConflictEntrySchema>;

// Body für POST .../severity-levels/:id/reassign bzw. .../error-types/:id/reassign — Muster
// wörtlich aus DataKindMergeSchema (packages/shared/src/schemas/catalog.ts), das Datenarten schon
// länger genauso umhängt (catalog-data-kinds.ts).
export const ReassignBodySchema = z.object({ target_id: z.string().uuid() });
export type ReassignBody = z.infer<typeof ReassignBodySchema>;
